import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Form, Row, Col, Button } from "react-bootstrap";
import { Formik } from "formik";
import * as yup from "yup";
import { useDispatch } from "react-redux";
import { adminLogin, saveUserToken } from "../../../reducers/commonReducer";
import {
  branchs,
  chatUsers,
  login,
  users,
} from "../../../const";
import { Link } from "react-router-dom";
import {
  ensureBrowserToken,
} from "../../../helpers/notificationToken";
import Header from "../../Sub/Header";

const schema = yup.object().shape({
  username: yup.string().required(),
  password: yup.string().required(),
  agreedToTerms: yup.bool().oneOf([true]),
}); 

const UserLogin = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const syncNotificationToken = async () => {
    try {
      const webToken = await ensureBrowserToken();

      if (!webToken) {
        console.warn("Browser notification token is still unavailable.");
        return;
      }

      await dispatch(saveUserToken({ webToken })).unwrap();
    } catch (error) {
      console.error("Failed to save browser notification token:", error);
    }
  };

  useEffect(() => {
    localStorage.removeItem("userEmail");
  }, []);
  return (
    <>
      <Header />
      <div className="container-fluid">
        <div className="page-main p-5 mbl-pedding-10">
          <div className="mb-40">
            <div className="text-center">
              <h1>Login your account.</h1>
            </div>
          </div>
          <Row>
            <Col md={6} sm={12} xs={12} className="mt-2 m-auto">
              <Formik
                validationSchema={schema}
                onSubmit={async (values, { resetForm }) => {
                  try {
                    const apiResp = await dispatch(adminLogin(values)).unwrap();
                    if (apiResp?.status) {
                      //await syncNotificationToken();
                      resetForm();
                      const token = localStorage.getItem("x-auth-token");
                      const slug = localStorage.getItem("slug");
                      
                      if (token && slug === "admin") {
                        navigate(branchs);
                      } else if (token && slug === "team_leader" || slug === "customer") {
                      navigate(chatUsers);
                      } else if (token && slug === "branch_leader") {
                        navigate(users);
                        window.location.reload();
                      } else {
                        navigate(login);
                      }
                    }
                  } catch (error) {
                    console.error("Login failed:", error);
                  }
                }}
                initialValues={{
                  username: "",
                  password: "",
                  agreedToTerms: false,
                }}
              >
                {({ handleSubmit, handleChange, touched, values, errors }) => (
                  <Form className="container" onSubmit={handleSubmit}>
                    <Row className="mb-3">
                      <Col md={12} sm={12}>
                        <Form.Group controlId="validationFormik01">
                          <Form.Label>Email/Phone</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Email/Phone"
                            name="username"
                            value={values.username}
                            onChange={handleChange}
                            isInvalid={!!errors.username}
                            className={
                              errors.username && touched.username && "errors"
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.username}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col md={12} sm={12}>
                        <Form.Group controlId="validationFormik01">
                          <Form.Label>Password</Form.Label>
                          <Form.Control
                            type="password"
                            placeholder="Password"
                            name="password"
                            value={values.password}
                            onChange={handleChange}
                            isInvalid={!!errors.password}
                            className={
                              errors.password && touched.password && "errors"
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.password}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col md={12} sm={12}>
                        <div
                          className="d-flex align-items-center gap-2 p-3 rounded"
                          style={{ background: "#f5f0c8" }}
                        >
                          <Form.Check
                            type="checkbox"
                            id="agreedToTerms"
                            name="agreedToTerms"
                            checked={values.agreedToTerms}
                            onChange={handleChange}
                            style={{ width: 20, height: 20, minWidth: 20, cursor: "pointer" }}
                          />
                          <Form.Label htmlFor="agreedToTerms" className="mb-0" style={{ fontSize: 13, cursor: "pointer" }}>
                            By proceeding, you agree to our{" "}
                            <Link to="/term-and-conditions" target="_blank" style={{ fontWeight: 700, color: "inherit" }}>
                              Terms &amp; Conditions
                            </Link>{" "}
                            and{" "}
                            <Link to="/privacy-policy-ios-app" target="_blank" style={{ fontWeight: 700, color: "inherit" }}>
                              Privacy Policy
                            </Link>
                            .
                          </Form.Label>
                        </div>
                      </Col>
                    </Row>
                    <Button
                      variant="success"
                      className="bg-thememain w-100"
                      type="submit"
                      disabled={!values.agreedToTerms}
                    >
                      <i className="bi bi-unlock-fill"></i> Login
                    </Button>
                  </Form>
                )}
              </Formik>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};

export default UserLogin;
